import React from 'react';
import { Link } from 'react-router-dom';

export type CategoryTabId = 'sobre' | 'jogos' | 'inscritos';

interface CategoryProfileTabsProps {
  activeTab: CategoryTabId;
  onTabChange: (tab: CategoryTabId) => void;
  categoryName?: string;
  torneioUrl?: string;
  sobreContent?: React.ReactNode;
  jogosContent?: React.ReactNode;
  inscritosContent?: React.ReactNode;
  exibirInscritos?: boolean | null;
}

const placeholder = (
  <div className="text-center py-4">
    <p className="text-muted">Em breve</p>
  </div>
);

const CategoryProfileTabs: React.FC<CategoryProfileTabsProps> = ({
  activeTab,
  onTabChange,
  categoryName,
  torneioUrl,
  sobreContent,
  jogosContent,
  inscritosContent,
  exibirInscritos,
}) => {
  return (
    <div className="card w-100 shadow-xss rounded-xxl border-0 mb-3">
      <div className="card-body p-0">
        {/* Nome da Categoria */}
        {categoryName && (
          <h4 className="fw-700 font-xs text-grey-900 px-3 pt-3 mb-0">{categoryName}</h4>
        )}

        {/* Abas */}
        <ul className="nav nav-tabs flex-wrap border-0 px-3 pt-3" role="tablist">
          {torneioUrl && (
            <li className="nav-item me-2 d-flex align-items-center">
              <Link
                to={torneioUrl}
                className="btn font-xssss fw-600 text-dark py-1 px-3 border-0 bg-transparent"
                style={{ lineHeight: '1.5' }}
              >
                <i className="bi bi-arrow-left me-1"></i>
                Ver torneio
              </Link>
            </li>
          )}
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'sobre' ? 'active' : ''}`}
              id="sobre-tab"
              type="button"
              role="tab"
              aria-controls="sobre"
              aria-selected={activeTab === 'sobre'}
              onClick={() => onTabChange('sobre')}
            >
              Sobre
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'jogos' ? 'active' : ''}`}
              id="jogos-tab"
              type="button"
              role="tab"
              aria-controls="jogos"
              aria-selected={activeTab === 'jogos'}
              onClick={() => onTabChange('jogos')}
            >
              Jogos
            </button>
          </li>
          {exibirInscritos && (
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${activeTab === 'inscritos' ? 'active' : ''}`}
                id="inscritos-tab"
                type="button"
                role="tab"
                aria-controls="inscritos"
                aria-selected={activeTab === 'inscritos'}
                onClick={() => onTabChange('inscritos')}
              >
                Inscritos
              </button>
            </li>
          )}
        </ul>

        {/* Divisória */}
        <div className="border-top"></div>

        {/* Conteúdo das Abas */}
        <div className="tab-content p-3">
          <div
            className={`tab-pane fade ${activeTab === 'sobre' ? 'show active' : ''}`}
            id="sobre"
            role="tabpanel"
            aria-labelledby="sobre-tab"
          >
            {sobreContent ?? placeholder}
          </div>
          <div
            className={`tab-pane fade ${activeTab === 'jogos' ? 'show active' : ''}`}
            id="jogos"
            role="tabpanel"
            aria-labelledby="jogos-tab"
          >
            {jogosContent ?? placeholder}
          </div>
          {exibirInscritos && (
            <div
              className={`tab-pane fade ${activeTab === 'inscritos' ? 'show active' : ''}`}
              id="inscritos"
              role="tabpanel"
              aria-labelledby="inscritos-tab"
            >
              {inscritosContent ?? placeholder}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CategoryProfileTabs;
